import { Modal as ModalModule } from 'common';
import { StatusModal } from 'common/src/code/modal/StatusModal.component';
import React, { useContext } from 'react';

const { ModalButtonActionType, ModalContext } = ModalModule;

interface PlanUpdatedSuccessModalProps {
	modalId: string;
}

const PlanUpdatedSuccessModal = ({ modalId }: PlanUpdatedSuccessModalProps) => {
	const { closeModal } = useContext(ModalContext);

	const handleClose = () => {
		(closeModal as any)(modalId);
	};

	return (
		<StatusModal
			modalId={modalId}
			header="Success"
			title="Your Plan Has Been Updated!"
			iconType="success"
			onClose={handleClose}
			dataqa="plan-updated-success-modal"
			primaryButton={{
				type: ModalButtonActionType.Ok,
				text: 'OK',
				onClick: handleClose,
			}}
		/>
	);
};

export default PlanUpdatedSuccessModal;
